<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader style="border-bottom: 0">
						Gestion des blocages colis
						<div class="card-header-actions">
							<CButton color="primary" v-on:click="showAddModal">
								<CIcon name="cil-lock-locked"></CIcon>
								Ajouter un/des blocage(s)
							</CButton>
						</div>
					</CCardHeader>

					<CCardBody>
						<GDataTableRemote
							ref="mainTable"
							:remote-url="`/api/order_items?blocked=1`"
							:fields="fields"
							:items-per-page="10"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #actions="{ item }">
								<td class="text-center">
									<a
										class="text-center icon-space"
										href="#"
										@click.prevent="showUnblockNotify(item)">
										<CIcon name="cil-lock-unlocked"></CIcon>
									</a>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>

		<AddModal ref="addModal" v-on:refresh="refresh()" />
	</div>
</template>
<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';
	import AddModal from './AddBlockedPagkage';

	export default {
		components: {
			GDataTableRemote,
			AddModal,
		},

		data() {
			return {
				fields: [
					{ key: 'id', label: 'Identifiant' },
					{ key: 'name', label: 'Nom du produit' },
					{ key: 'shippingDate', label: "Date d'expédition", type: 'date' },
					{ key: 'deliveryDate', label: 'Date de livraison', type: 'date' },
					{ key: 'actions', filter: false },
				],
				activePage: 1,
			};
		},

		methods: {
			showAddModal: function () {
				this.$refs.addModal.showModal = true;
			},
			showUnblockNotify: function (item) {
				if (confirm('Êtes-vous sûr de vouloir débloquer ce colis ?')) {
					this.$axios
						.patch(
							item['@id'],
							{
								blocked: false,
							},
							{
								headers: {
									'Content-Type': 'application/merge-patch+json',
								},
							}
						)
						.then(res => {
							this.$toast.success(`La colis ${item.name} - ${item.uuid} a bien été débloqué`);
							this.$refs.mainTable.refresh();
						});
				}
			},
			refresh: function () {
				this.$refs.mainTable.refresh();
			},
		},
	};
</script>
<style>
	.icon-space {
		margin-right: 10px;
	}

	.badge-warning {
		color: white;
	}
</style>
